import React from 'react'
import { 
  SUB_HEADERS,  
  INFO_REVENUE, 
  ICON, 
  DEFAULT_NUMBER, 
  FIELD_RESULT_NAMES, 
  MAIN_RESULT_NAME,
  CURRENCY,
  PERCENTAGE,
  FIELD_LABEL_REVENU,
  FIELD_TYPES,
  EMPTY,
  INCREMENT,
  DEFAULT_STEP,
  BUTTON
} from "../../constants.jsx"
import CalculatorSubHeader from "../Global/Header/components/sub.tsx"
import Field from "../Global/Fields/index.tsx"
import CalculatorCounter from "../Global/Counters/index.tsx"
import { ISteps5 } from "../../types.tsx"
import PreResult from "../Global/Fields/Result/preResult.tsx"
import ButtonLink from "../Global/Buttons/link.tsx"
import Button from "../Global/Buttons/index.tsx"
import Results from "../Global/Fields/Result/index.tsx"
import { customRound } from "../../helper.ts"

const Summary: React.FC<ISteps5> = ({clickHandler, step, values, step1Result, step2Result}) => {

  return (
    <div className="calculator__revenue">
        <div className='calculator__sub-header'>
            <CalculatorSubHeader text={SUB_HEADERS.SUMMARY} />
        </div>
        <CalculatorCounter step={step || 2} slideStep={1} />
        <div className='calculator__fields'>
        <PreResult 
            name={MAIN_RESULT_NAME.REVENUE}
            result={step1Result || 0}
            currency={CURRENCY}
          />
       <br></br>
       <br></br>
        </div>
        <Results 
          name={MAIN_RESULT_NAME.LAST}
          result={step2Result || 0}
          currency={CURRENCY}
        />
        <div className='calculator__buttons'>
        <Button 
              text={BUTTON.BACK}
              outlined={true}
              step={(step || 0 )-INCREMENT}
              clickHandler={clickHandler}
            />
            <ButtonLink 
              text={BUTTON.DEMO}
              outlined={false}
            />
        </div>
    </div>
  );
}

export default Summary
